import imageToBase64 from 'image-to-base64/browser';
import loadImage from "../../../noncomponents/loadImage"
import { useEffect } from 'react';
import * as d3 from "d3";

function Legend({ data, svgWidth, chainSelection, clickSelection, hoverSelection,
  connectionChains }) {

  const linkColors = ['#f28f2d', '#76b6b3', '#f1f1f1'];
  const strokeOranje = linkColors[0];
  const strokeBlauw = linkColors[1];

  let yPosition = 0;

  const iconColor = require('../../../assets/data/icons_witterand/Sterfte van planten en bomen en verlies biodiversiteit in natuurgebieden met vochtminnende ecosystemen.png');
  const iconGrey = require('../../../assets/data/images/grijsIcoon3.png');

  useEffect(() => {
    imageToBase64(iconColor) // Path to the image
      .then(
          (response) => {
              d3.select('.iconColor')
                .attr('href', "data:image/jpeg;charset=utf-8;base64," + response)
          }
      ).catch((error) => {console.log(error);})

      imageToBase64(iconGrey) // Path to the image
        .then(
            (response) => {
                d3.select('.iconGrey')
                  .attr('href', "data:image/jpeg;charset=utf-8;base64," + response)
            }
        ).catch((error) => {console.log(error);})
  })

  let legendaTitel = null;
  if(chainSelection >= 0){
    legendaTitel = (
        <g transform={`translate(105,${yPosition})`}>
          <text fill='#635F5D' dy='0.3em' x='10' textAnchor='end' fontWeight='bold' fontSize='11'>
            {'Keten: ' + data.filter(d => +d.ID === chainSelection)[0]['oorzaakeffectimpact_kort']}
          </text>
        </g>
      )
    yPosition += 25;
  }

  let geselecteerdIcoon = null;
  if(chainSelection >= 0){
    geselecteerdIcoon = (
        <g transform={`translate(0,${yPosition})`}>
          <circle r='9' stroke='#f28f2d' fill='none' cx='-15' strokeWidth='3'/>
          <text dy='0.3em' x='10'>
            Geselecteerde impact
          </text>
        </g>
      )
    yPosition += 25;
  }

  let dashIcoon = null;
  if(clickSelection !== chainSelection){
    dashIcoon = (
        <g transform={`translate(0,${yPosition})`}>
          <circle r='9' stroke='grey' fill='none' cx='-15' strokeWidth='3'
            strokeDasharray='5,5'/>
          <text dy='-0.1em' x='10'>
            Geselecteerde oorzaak/
          </text>
          <text dy='0.9em' x='10'>
            effect binnen keten
          </text>
        </g>
      )
    yPosition += 25;
  }

  let kleurIcoon = null;
  if(chainSelection >= 0 || hoverSelection >= 0){

    kleurIcoon = (
        <g transform={`translate(0,${yPosition})`}>
          <image className='iconColor' width='24'
            x='-27' y='-13' opacity='0.7'/>
          <text dy='-0.1em' x='10'>
            oorzaak/effect met
          </text>
          <text dy='0.9em' x='10'>
             directe relatie (kleur)
          </text>
        </g>
      )
    yPosition += 25;
  }

  let grijsIcoon = null;

  if(chainSelection >= 0 || hoverSelection >= 0){
    // if(d3.selectAll('image')){
      grijsIcoon = (
          <g transform={`translate(0,${yPosition})`}>
            <image className='iconGrey' width='24'
              x='-27' y='-13' opacity='0.55'/>
            <text dy='-0.1em' x='10'>
              oorzaak/effect met
            </text>
            <text dy='0.9em' x='10'>
               indirecte relatie (grijs)
            </text>
          </g>
        )
      yPosition += 25;
    // }
  }

  let gevolgPijl = null;
  if(chainSelection >= 0 || hoverSelection >= 0){
    gevolgPijl = (
      <g transform={`translate(0,${yPosition})`}>
        <marker id={"arrow_legend_" + strokeOranje} viewBox="0 0 10 10" refX={"5"} refY="5"
            markerWidth="8" markerHeight="8"
            orient="auto-start-reverse" fill={strokeOranje}>
          <path d="M 0 0 L 5 10 L 10 0 z" />
        </marker>


        <path
          d={'M0 0 L40 0 Z'}
          transform={'rotate(180)'}
          fill='none'
          stroke={strokeOranje}
          strokeWidth='1.3'
          markerEnd={"url(#arrow_legend_" + strokeOranje + ")"}
          opacity='1'
          pointerEvents='none'
        />
        <text dy='0.3em' x='10'>
          Veroorzaakt door
        </text>
      </g>
    );
    yPosition += 20;
  }

  let oorzaakPijl = null;
  if(chainSelection >= 0 || hoverSelection >= 0){
    oorzaakPijl = (
      <g transform={`translate(0,${yPosition})`}>
        <marker id={"arrow_legend_" + strokeBlauw} viewBox="0 0 10 10" refX={"5"} refY="5"
            markerWidth="8" markerHeight="8"
            orient="auto-start-reverse" fill={strokeBlauw}>
          <path d="M 0 0 L 5 10 L 10 0 z" />
        </marker>
        <path
          d={'M0 0 L40 0 Z'}
          transform={'rotate(180)'}
          fill='black'
          stroke={strokeBlauw}
          strokeWidth='1.3'
          markerEnd={"url(#arrow_legend_" + strokeBlauw + ")"}
          opacity='1'
          pointerEvents='none'
        />
        <text dy='0.3em' x='10'>
          Heeft tot gevolg
        </text>
      </g>
    );
    yPosition += 20;
  }

  return (

    <g className="Legend" transform={`translate(${svgWidth-125}, 20)`} fontSize='10'
      fill='#635F5D'>

      {legendaTitel}
      {geselecteerdIcoon}
      {dashIcoon}
      {kleurIcoon}
      {grijsIcoon}
      {gevolgPijl}
      {oorzaakPijl}

    </g>


  );


}

export default Legend;
